<template lang="pug">
  div(class="documents-table-selectable")
    div(class="documents-table-selectable__content")
      h2(class="title-32px fw-700 mb-2") {{ $t('Link documents') }}
      p(class="text-14px fw-300 mb-8") {{ $t('Connection with') }}
        span(class="text-14px dark fw-700 pl-1") “{{ document.title }}”
      e-input-debounce(
        v-model="search"
        :placeholder="$t('Documents search')"
        data-test="documents-search-input"
        class="mb-8"
      )
      m-table(
        store-name="documents"
        sort-by="createdAt"
        sort-desc
        show-select
        :headers="headers"
        :search="search"
        :query-filter="queryFilter"
        @selected="selectedDocuments = $event"
      )
    div(class="documents-table-selectable__footer")
      div(class="two-buttons-wrapper w-100")
        v-btn(
          height="48"
          @click="closeModal(false)"
        ) {{ $t('Cancel') }}
        v-btn(
          class="main-button"
          :loading="loading"
          @click="relateDocuments"
        ) {{ $t('Link up documents') }}
</template>

<script>
import EInputDebounce from '~/components/elements/inputs/e-input-debounce'
import MTable from '~/components/modules/tables/m-table'
import { formats } from '~/const/global'

export default {
  components: {
    EInputDebounce,
    MTable
  },
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    document: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      search: null,
      selectedDocuments: [],
      loading: false
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'title',
          sortable: true,
          filterable: true
        },
        {
          text: 'Date uploading',
          value: 'createdAt',
          valueFormatter: document => this.$moment(document.createdAt).format(formats.date),
          sortable: true,
          filterable: true
        },
        {
          text: 'Status',
          value: 'status',
          component: 'block-documents-status-and-send-date',
          sortable: false,
          filterable: false
        },
        {
          text: 'Counterpart',
          valueFormatter: document => {
            const counterparties = this._.get(document, 'counterparties', [])
            if (document.hasPublicAccess) {
              return this.$t('Everyone, who has link')
            }
            if (this._.isEmpty(counterparties)) {
              return '-'
            }
            return `${counterparties[0]}${counterparties.length > 1 ? '…' : ''}`
          },
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        hideRelated: true
      }
    }
  },
  methods: {
    async relateDocuments() {
      try {
        this.loading = true
        const relatedDocumentIds = this._.map(this.selectedDocuments, document => document.id)
        await this.$store.dispatch('documents/relateDocuments', {
          id: this.document.id,
          payload: {
            relatedDocumentIds
          }
        })
        const updatedDocument = await this.$store.dispatch('documents/read', {
          id: this.document.id
        })
        this.closeModal(updatedDocument)
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.documents-table-selectable {
  position: relative;

  &__content {
    padding: 40px;
  }

  &__footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 40px;
    background-color: $white;
    border-top: 1px solid $border-disabled;
  }
}
</style>
